import { render, staticRenderFns } from "./LineUp.vue?vue&type=template&id=5a379fff&scoped=true"
import script from "./LineUp.vue?vue&type=script&lang=js"
export * from "./LineUp.vue?vue&type=script&lang=js"
import style0 from "./LineUp.vue?vue&type=style&index=0&id=5a379fff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a379fff",
  null
  
)

export default component.exports